import { render, staticRenderFns } from "./DnTable.vue?vue&type=template&id=2ebab5a3"
import script from "./DnTable.vue?vue&type=script&lang=ts"
export * from "./DnTable.vue?vue&type=script&lang=ts"
import style0 from "./DnTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports